/**
 * Description: 应用于本系统正则
 * @author: lhc
 * @date: 2022/1/10 15:35
 */
const SysRegExp = {

  /**
   * Description: 条码号,用于查询
   * 规则：以A/R开头后面加22个数字
   * @author: lhc
   * @date: 2022/2/9 10:26
   */
  // _TMH: /^[aArR]{0,1}[0-9]{0,22}[\*\?]{0,1}$/
  _TMH: `^[a-zA-Z0-9]{0,23}[\\*\\?]{0,1}$` // 兼容老系统，后22位包含字母
}

export default SysRegExp
